import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Physician,PhysicianData} from '../../../../@core/interfaces/masters/physician-mst'; 

import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { LabWorkOrderData } from '../../../../@core/interfaces/lab/lab-work-order'; 
import { Labresultmst, LabresultmstData} from '../../../../@core/interfaces/masters/labresultmst'; 
//UTC Time
import { DateService } from '../service/date.service'; 
import { LabResultData } from '../../../../@core/interfaces/lab/lab-result-detail';
// import { PatientvitalstargetComponent } from '../../../../pages/EHR/patientvitalstarget/patientvitalstarget.component';
import { MedicineData } from '../../../../@core/interfaces/masters/medicine'; 
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BillServiceWiseReportData } from '../../../../@core/interfaces/report/bill-service-wise-report';
@Component({
  selector: 'ngx-lab-reports',
  templateUrl: './lab-reports.component.html',
  styleUrls: ['./lab-reports.component.css']
})
export class LabReportsComponent implements OnInit {
  p: number = 1;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");


  protected readonly unsubscribe$ = new Subject<void>();

  @Input() regId: string;
  visitId:number=1;

  data: Labresultmst[] = [];
  labTest: any = [{ name: "lab order wise", class: "ord-ic" }, { name: "Test wise", class: "test-ic" }]


  physicianList: Physician[];
  pageTaskIds: any = [];
  private apiUrl = environment.apiUrl;
  userAccessData: any;
  isView: boolean = false;
  isEdit: boolean = false;
  isCreate: boolean = false;
  isPrint: boolean = false;
  rangeDate: Date[];
  term: string;
  searchword:string;
  fullData: Labresultmst[] = [];
  viewReport: boolean = false;
  labreportpage: boolean = false;
  IslabOrderWise: boolean = false;
  showtargetForm:FormGroup;
  IsTestWise: boolean = false;
  DefaultSelectButton: boolean = false;
  DefaultSelectButtonTwo: boolean = false;
  id: any;
  lId: any;
  showHistoryHeaders: any[] = [];
  showHistoryBody: any[] = [];
  targetdatas: any[] = [];
  showHistoryDump: any[] = [];
  showHistoryTable: boolean = false;
  showallHistoryTable: boolean = false;
  showallHistoryHeaders: any[] = [];
  showallHistoryBody: any[] = [];
  showallHistoryDump: any[] = [];
  showHistoryHtmlTable: any = '';
  ischartShow: boolean = false;
  view: any[] = [700, 300];
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Completed Date';
  yAxisLabel: string = 'Result Value';
  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  seriesList: any[] = [];
  gradient: boolean = false;
  showvitalspage:boolean=false;
  // @ViewChild('patientVitalsTab') patientVitalsTabInstance: PatientvitalstargetComponent;
  nextdurationdata:Date;
  serviceData:Array<any>=[];
  vitalsData:any;
  isSaveconfirmation:boolean=false;
  isUpdateconfirmation:boolean=false;
  patientVitalsTargetForm: FormGroup;

  saveServiceTarget: Array<any> = [];
  min=new Date();
  isAddComponent:boolean=true;
  serviceLists:Array<any>=[];
  vitalsTargetAddComponent:boolean=false;
  resultdialog:boolean=false;

  serviceGoalForm:FormGroup;
  lastVisitId:number;
  @Input() patientIPOPStatus:string;
  goalSetted:boolean=false;
  goalData:Array<any>=[];
   groupedData:Array<any>=[];


  constructor(protected postAPI: BillServiceWiseReportData,private fb: FormBuilder,protected callAPI: MedicineData,private dateService: DateService, protected rolesService: RolesData, private labWorkOrderService: LabWorkOrderData, protected router: Router, protected labResult: LabresultmstData, protected physicianData: PhysicianData, protected labResultSrvc: LabResultData, private dateSrvc: DateService) {
    this.patientVitalsTargetForm = this.fb.group({
      weight: this.fb.control(null,[Validators.min(1), Validators.max(200),Validators.pattern('^[0-9.]+$')]),
      height: this.fb.control(null,[Validators.min(30), Validators.max(220),Validators.pattern('^[0-9.]+$')]),
      bPSys: this.fb.control(null, [Validators.min(0), Validators.max(500),Validators.pattern('^[0-9.]+$')]),
      bPDia: this.fb.control(null, [Validators.min(0), Validators.max(500),Validators.pattern('^[0-9.]+$')]),
      pulse: this.fb.control(null, [Validators.min(30), Validators.max(200),Validators.pattern('^[0-9.]+$')]),
      temp: this.fb.control(null, [Validators.min(0), Validators.max(200),Validators.pattern('^[0-9.]+$')]),
      heartRate: this.fb.control(null, [Validators.min(0), Validators.max(200),Validators.pattern('^[0-9.]+$')]),
      respRate: this.fb.control(null, [Validators.min(0), Validators.max(200),Validators.pattern('^[0-9.]+$')]),
      headcircumference: this.fb.control(null, [Validators.min(30), Validators.max(600), Validators.pattern('^[0-9.]+$')]),
      spo2: this.fb.control(null, [Validators.min(10), Validators.max(150), Validators.pattern('^[0-9.]+$')]),
      targetStopDate: this.fb.control(null,[Validators.required]),
      stresslevel:this.fb.control(null),
      exercise:this.fb.control(null)

    });   

    this.showtargetForm = this.fb.group({
      showtarget:this.fb.control(null)
    });   

    this.serviceGoalForm = this.fb.group({
      service:this.fb.control(null),
      startDate:this.fb.control(null,Validators.required),
      stopDate:this.fb.control(null,Validators.required),
      targetValue:this.fb.control(null,[Validators.required,Validators.pattern('^[0-9.]+$')]),
      initialNotes:this.fb.control(null),
      progressNotes:this.fb.control(null),
      stopNotes:this.fb.control(null)
    });  
  }

  
  
  get fval(): {[key: string]: AbstractControl} { return this.patientVitalsTargetForm.controls; }
  get fval2(): {[key: string]: AbstractControl} { return this.serviceGoalForm.controls; }

  ngOnInit(): void {
    this.fetchDefaultbtn()
  }


  startPatientData() {
    this.LoadLabResultMst();
    this.loadPhysician();
   
    this.labreportpage = true;
    this.viewReport = false;
    this.showAllhistory();
    this.fetchAllData();

  }
  Ipchecked:boolean=false;
  Opchecked:boolean=false;
  Allchecked:boolean=true;


  LoadLabResultMst(): void {

    this.labResult.list("labresultmst/getLabReportDet/" + this.tenandId + "/" + this.branchId + "/" + this.regId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      this.fullData = data;
      this.data = data.filter(x => x.status == "Completed" || x.status == "In-Progress");

    }, (error) => {

    }, () => {
    
    });
  }
 


  


  
  select(kind: 'All' | 'IP' | 'OP'): void {
    if (kind === 'All') {
      this.Allchecked = true;
      this.Ipchecked = false;
      this.Opchecked = false;
    } else if (kind === 'IP') {
      this.Allchecked = false;
      this.Ipchecked = true;
      this.Opchecked = false;
    } else {
      this.Allchecked = false;
      this.Ipchecked = false;
      this.Opchecked = true;
    }
  
    this.applyFilter();
  }
  
  applyFilter(): void {
    const arr = this.fullData || [];
    if (this.Ipchecked) {
      this.data = arr.filter(x =>
        (x.status === 'Completed' || x.status === 'In-Progress') && x.type === 'IP'
      );
    } else if (this.Opchecked) {
      this.data = arr.filter(x =>
        (x.status === 'Completed' || x.status === 'In-Progress') && x.type === 'OP'
      );
    } else {
      // All
      this.data = arr.filter(x => x.status === 'Completed' || x.status === 'In-Progress');
    }
  }
  

 

  

  loadPhysician(): void {
    this.physicianData.list("physicians/" + this.tenandId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.physicianList = data.value;
    }, (error) => {
    }, () => {

    });
  }


  getPhysicianName(id: any): string {
    if (id != null && id != undefined && id != '') {
      return ((this.physicianList as Array<any>)?.find(x => x.id == id).name);
    }
  }

  // goLabresultPrint
  onLabResultPrint(x,isWtsap?) {
    let searchData = {
      billId: x.billId,
      fromDate: null,
      toDate: null,
      skip: 0,
      take: 100,
      regId: ""
    }

    this.id = x.billId;
      this.lId = x.workOrderId;
    if(isWtsap){
      this.router.navigate(['/pages/lab/labresultentryprint', this.id, this.lId, 'share'])
    }
    else{
      localStorage.setItem('Printselection',JSON.stringify([]));
    localStorage.setItem('removedPrintselection',JSON.stringify([]));
      this.router.navigate([
        '/pages/lab/labresultentryprint',
        this.id,
        this.lId,
        { Isprintall: 'Y' }
      ]);
    }
    // this.labWorkOrderService.searchList(this.tenandId + '/' + this.branchId + '/labworkordermst/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    //   console.log(data, 'data')
    //   this.id = data.lwoFromDb[0]?.referenceNo;
    //   this.lId = data.lwoFromDb[0]?.id;
    //   if(isWtsap){
    //     this.router.navigate(['/pages/lab/labresultentryprint', this.id, this.lId, 'share'])
    //   }
    //   else{
    //     localStorage.setItem('Printselection',JSON.stringify([]));
    //   localStorage.setItem('removedPrintselection',JSON.stringify([]));
    //     this.router.navigate([
    //       '/pages/lab/labresultentryprint',
    //       this.id,
    //       this.lId,
    //       { Isprintall: 'Y' }
    //     ]);
        
    //   }
    // });

  }
  //Search Filter
  onSearch() {
    let fDate;
    let tDate;
    if (this.rangeDate !== null && this.rangeDate !== undefined) {
      if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
        this.rangeDate[1] = this.rangeDate[0];
      }
      else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
        this.rangeDate[0] = this.rangeDate[1];
      }
      fDate = this.dateService.newDate(this.rangeDate[0]);
      tDate = this.dateService.newDate(this.rangeDate[1]);
    }
    if (this.term == "" || this.term == undefined)
      this.term = null;
    let searchData = {
      searchWord: this.term,
      fromDate: fDate,
      toDate: tDate,
    }

    this.data = this.fullData?.filter(x =>
      searchData.fromDate.getTime() <= new Date(x.sampleDate)?.getTime() && new Date(x.sampleDate)?.getTime() <= searchData.toDate.getTime());
  }
  
  ActiveButton(data) {


    if (data == 'LabOrderWise') {
      this.IslabOrderWise = true;
      this.IsTestWise = false;
      this.DefaultSelectButtonTwo = false;
      this.DefaultSelectButton = true;
    }
    if (data == 'TestWise') {
      this.showhistory();
      this.IslabOrderWise = false;
      this.IsTestWise = true;
      this.DefaultSelectButtonTwo = true;
      this.DefaultSelectButton = false;
    }

  }


  fetchDefaultbtn() {
    this.DefaultSelectButton = true;
    this.IslabOrderWise = true;
    this.IsTestWise = false;
  }

  showhistory() {

    var test = {
      "FromDate": "",
      "ToDate": "",
      "RegId": this.regId,
      "TenantId": this.tenandId,
      "BranchId": this.branchId
    }


    this.labResultSrvc.reportList(`labresultmst/vitalsTargetReport`, test)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        
        this.showHistoryHeaders.length=0;
        this.showHistoryBody.length=0;
        
   
      this.showHistoryHeaders=data.returnValue;
        this.showHistoryDump = data.returnValue;
        this.showHistoryTable = data.returnValue.length > 0 ? true : false;

        this.groupedData = this.groupBy(this.showHistoryHeaders);
      
      }, (error) => {

      }, () => {
      });
      this.onLoadServices();
  }
  groupBy(data): any[] {
    const flattenedData = data.flat();
    const grouped = flattenedData.reduce((result, currentItem) => {
      const key = currentItem.serviceId;
      if (!result[key]) {
        result[key] = {
          serviceId: key,
          serviceName: currentItem.serviceName,
          latestValue: currentItem.labResultValue,
          latestDate: currentItem.completedDate,
          det: []
        };
      }
      result[key].det.push(currentItem);

      if (new Date(currentItem.completedDate) > new Date(result[key].latestDate)) {
        result[key].latestValue = currentItem.labResultValue;
        result[key].latestDate = currentItem.completedDate;
      }

      return result;
    }, {});

    return Object.values(grouped);
  }
  getLabResultValue(det: any[], date: string): string {
    const record = det.find(record => record.completedDate === date);
    return record ? record.labResultValue : '-';
  }


  uniqueDates(): string[] {
    const datesSet = new Set<string>();
    for (const testArray of this.showHistoryHeaders) {
      for (const test of testArray) {
        datesSet.add(test.completedDate);
      }
    }
    return Array.from(datesSet);
  }

  labReportprevclicked() {
    if (this.p > 1)
      this.p = this.p - 1
  }
  labReportnextclicked() {
    if (this.p < (this.fullData.length / 10)) {
      this.p = this.p + 1
    }
  }
  loadGraph(y) {
    var searies = [];
    this.seriesList = [];
    for (var i = 0; i < y.Value.length; i++) {
      if (y.Value[i] != "-") {
        searies.push({ "name": y.CompletedDate[i].toString(), "value": y.Value[i].toString() });  // can take only x y values

      }

    }
    this.seriesList.push({ "name": "Value", "series": searies });
    this.ischartShow = true;
  }

  loadgraph(y) {
    var searies = [];
    this.seriesList = [];
    if(y.length!=0){
      y.sort((a,b)=>{
        return new Date(a.completedDate).getTime() - new Date(b.completedDate).getTime();
      });
    }
    
    for (var i = 0; i < y.length; i++) {
      if (!!y[i].labResultValue && this.isNumeric(y[i].labResultValue)) {
        searies.push({ "name": new Date(y[i]?.completedDate+"Z").toString(), "value": y[i].labResultValue.toString() });  // can take only x y values
      }

    }
    this.seriesList.push({ "name": "Value", "series": searies });
    this.ischartShow = true;
  }


  closeGraph() {
    this.ischartShow = false;
  }
  onReset() {

    this.term = "";
    this.rangeDate = null;
    this.LoadLabResultMst();
    this.Allchecked=true
    this.select('All')

  }
  downloadFile(x) {

    let searchData = {
      searchWord: x.billId,
      fromDate: null,
      toDate: null,
      skip: 0,
      take: 100
    }
    this.labWorkOrderService.searchList(this.tenandId + '/' + this.branchId + '/labworkordermst/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var link = "/pages/lab/labresultentryprint/" + data[0]?.referenceNo + "/" + data[0]?.id + "?";
      this.router.navigate([`${link.split('?')[0]}`], { queryParams: { download: true } });
    });

  }
  isOn = false;

  onToggle(event) {
    this.isOn = event.checked;
  }


  closeVitalsPopup(){
    this.showvitalspage=false;
    this.searchword = null;
  }
  patientvitalsclose(){
    this.showvitalspage=false;
    if(this.vitalsTargetAddComponent){
      this.isSaveconfirmation=true;
      setTimeout(() => { 
        this.isSaveconfirmation = false; 
      }, 4000);
      this.vitalsTargetAddComponent=false;
    }else{
      this.isUpdateconfirmation=true;
      setTimeout(() => { 
        this.isUpdateconfirmation = false; 
      }, 4000);   
    }
  }



  onLoadServices(){
    
    this.nextdurationdata=null;
    this.serviceLists=[];
    this.vitalsData=[];
    this.callAPI.medicinePresctiptionGet("labtest/" + this.tenandId + '/' + this.branchId +  '/' + this.regId +  '/GetSeviceTargetValue/'+this.visitId).pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
      

      if(returnData?.patientVitalLists == null){
        this.vitalsTargetAddComponent=true;
        this.serviceLists=returnData.list;
      }else{

        this.vitalsTargetAddComponent=false;
        this.patientVitalsTargetForm.controls['weight'].setValue(returnData?.patientVitalLists.weight);
        this.patientVitalsTargetForm.controls['height'].setValue(returnData?.patientVitalLists.height);
        this.patientVitalsTargetForm.controls['bPSys'].setValue(returnData?.patientVitalLists.sysBP);
        this.patientVitalsTargetForm.controls['bPDia'].setValue(returnData?.patientVitalLists.diaBp);
        this.patientVitalsTargetForm.controls['targetStopDate'].setValue(returnData?.patientVitalLists.targetStopDate);
        this.patientVitalsTargetForm.controls['stresslevel'].setValue(!!this.vitalsData.stressLevel?this.vitalsData.stressLevel:'');
        this.patientVitalsTargetForm.controls['exercise'].setValue(!!this.vitalsData.excercise?this.vitalsData.excercise:'');
        this.serviceLists=returnData.patientServiceLists;
      }

      if(this.showvitalspage){
        this.onReset();
      }

      if(!!returnData.patientVitalLists){
        this.nextdurationdata=this.dateService.dateUtctoLocalDateAndTime(returnData.patientVitalLists?.targetStopDate)
      }
      else{
        this.nextdurationdata=null;
      }

      if(returnData?.patientServiceLists?.length==0){
        this.serviceLists= returnData.list;
      }
     

      if(returnData?.patientVitalLists?.length==0){
        this.vitalsData= returnData.list2?.[0];
      }
      else{
        this.vitalsData= returnData?.patientVitalLists;
      }

    }, (error) => {
 
    }, () => {
    
    });
  }

  showpatientvitalspage(){
    this.showvitalspage=true;
    this.onLoadServices();
  }

  collecttargetvalues(){
    this.showHistoryBody=[];
    if(this.showtargetForm.get('showtarget').value){
      this.showHistoryBody=this.targetdatas.filter(x=>x.TargetValue!=0 && x.TargetValue!=null)
    }
    else{
      this.showHistoryBody=this.targetdatas;
    }
  }


 




  serviceTargetRangeOnChange(index,event){


    if(this.vitalsTargetAddComponent){
      this.serviceLists[index].targetRange=event.target.value;
    }else{
      this.serviceLists[index].targetValue=event.target.value;


    }
      }
    

    
      onSave(){
        
        if(this.patientVitalsTargetForm.valid){
        this.saveServiceTarget.length=0;
        if(this.vitalsTargetAddComponent){
          if(this.serviceLists?.length){
            this.serviceLists.forEach(element => {
              this.saveServiceTarget.push({
             "VisitId":this.visitId,
             "RegId":this.regId,
             "IPId":null,
             "ServiceId":element.serviceId,
             "TargetValue":element.targetRange?element.targetRange:0,
             "CurrentValue":element.currentValue==null?0:parseFloat(element.currentValue),
             "TargetType":null,
             "TargetStartedDate":new Date(),
             "TargetStopDate":this.patientVitalsTargetForm.get('targetStopDate').value,
             "TargetActiveStatus":"Y",
             "CreatedBy":parseInt(localStorage.getItem("userId")),
             "CreatedDate":new Date(),
             "UpdatedBy":null,
             "UpdatedDate":null,
             "CreatedIP":null,
             "UpdatedIP":null,
             "TenantId":this.tenandId,
             "BranchId":this.branchId   })
             
                   });
          }
          
        }else{
    
          if(this.serviceLists!=null && this.serviceLists!=undefined){
            this.serviceLists.forEach(element => {
              this.saveServiceTarget.push({
             "VisitId":this.visitId,
             "RegId":this.regId,
             "IPId":null,
             "ServiceId":element.serviceId,
             "TargetValue":element.targetValue ? element.targetValue : 0,
             "CurrentValue":element.currentValue==null?0:parseFloat(element.currentValue),
             "TargetType":null,
             "TargetStartedDate":new Date(),
             "TargetStopDate":this.patientVitalsTargetForm.get('targetStopDate').value,
             "TargetActiveStatus":"Y",
             "CreatedBy":parseInt(localStorage.getItem("userId")),
             "CreatedDate":new Date(),
             "UpdatedBy":null,
             "UpdatedDate":null,
             "CreatedIP":null,
             "UpdatedIP":null,
             "TenantId":this.tenandId,
             "BranchId":this.branchId   })
             
                   });
          }
     
        }
    
    
          let saveData={
    "saveServiceTarget":this.saveServiceTarget,
    "patientVitalPMTargetMst":{
      "VisitId":this.visitId,
      "RegId":this.regId,
      "IPId":null,
      "DiaBp":this.patientVitalsTargetForm.get('bPDia').value,
      "SysBP":this.patientVitalsTargetForm.get('bPSys').value,
      "Height":this.patientVitalsTargetForm.get('height').value,
      "Weight":this.patientVitalsTargetForm.get('weight').value,
      "StressLevel":this.patientVitalsTargetForm.get('stresslevel').value,
      "Excercise":this.patientVitalsTargetForm.get('exercise').value,
      "TargetStartedDate":new Date(),
      "TargetStopDate":this.patientVitalsTargetForm.get('targetStopDate').value,
      "TargetActiveStatus":'Y',
      "CreatedBy":parseInt(localStorage.getItem("userId")),
      "CreatedDate":new Date(),
      "UpdatedBy":null,
      "UpdatedDate":null,
      "CreatedIP":null,
      "UpdatedIP":null,
      "TenantId":this.tenandId,
      "BranchId":this.branchId,
    }
          }
    
          if(this.vitalsTargetAddComponent){
            this.postAPI.searchList(`patientServiceTarget/createPatientTarget`,saveData).pipe(takeUntil(this.unsubscribe$)).subscribe((returnData:any)=>{
              this.serviceLists=returnData?.patientServiceLists;
             if(this.serviceLists != null){
              this.serviceLists.length=0;
    
             }
                    });
              this.vitalsTargetAddComponent=false;
          }else{
            this.postAPI.searchList(`patientServiceTarget/updatePatientTargets`,saveData).pipe(takeUntil(this.unsubscribe$)).subscribe((data:any)=>{
                  });
          }
          this.showhistory();
          this.onLoadServices();

          this.patientvitalsclose();
        
        }
        
       
      }


      showHistoryPopUp(){
        this.resultdialog = true; 
        this.showAllhistory();
      }
      showAllhistory(){
    
       var test =  {
          "FromDate": "",
          "ToDate": "",
          "RegId": this.regId,
          "TenantId": this.tenandId,
          "BranchId": this.branchId
      }
    
    
        this.labResultSrvc.reportList(`labresultmst/labResultsByRegId`,test)
        .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {    
          this.showallHistoryHeaders = [];
          this.showallHistoryBody = [];
          this.showallHistoryHeaders.push('TestName'); 
          this.showallHistoryHeaders.push('DeptName'); 
          this.showallHistoryDump = data.returnValue; 
          this.showallHistoryTable = data.returnValue.length > 0 ? true : false ; 
          if (!this.showallHistoryTable){
            return false ; 
          }
          let loopvalidation : boolean = false; 
          for (let i =0 ; i < data.returnValue.length ; i ++){
                for(let j=0; j < data.returnValue[i].length; j++){
                  for (let z =0 ; z< this.showallHistoryHeaders.length ; z++ ) {
                    if ( data.returnValue[i][j].completedDate ==   this.showallHistoryHeaders[z] ){
                      loopvalidation = false ; 
                      break; 
                    }
                    else {
                      loopvalidation = true; 
                    }
                  }
    
                  if (loopvalidation == true){
                    this.showallHistoryHeaders.push( new Date(this.dateSrvc.dateUtctoLocal(data.returnValue[i][j].completedDate,""))); 
                  }
                }
                
          }
      
          for (let i =0 ; i < data.returnValue.length ; i ++){
            var showHistorytbody = {
              TestName : data.returnValue[i][0].serviceName , 
              DeptName : data.returnValue[i][0].departmentName , 
              Value : [] , 
              CompletedDate:[]
            }
            let values =[];
            let cDate = [];
    
            for(let j=0; j < data.returnValue[i].length; j++)
            {
            
                  var value = "";
                  var comDate = new Date();
                  for (let z =2 ; z< this.showallHistoryHeaders.length ; z++ ) { 
                    
                    
                    if(new Date(this.dateSrvc.dateUtctoLocal(data.returnValue[i][j].completedDate,"")).getTime() === this.showallHistoryHeaders[z].getTime())
                    {
                      
                       value = data.returnValue[i][j].labResultValue;
                       comDate = new Date(this.dateSrvc.dateUtctoLocal(data.returnValue[i][j].completedDate,""));
                       break;
                    }
                    else 
                    {
                    
                      values.push("-");
                      cDate.push("-");
                    }
                 
                }
                if(value != "")
                {
                 values.push(value);
                 cDate.push(comDate);
                }
            
    
                
          }
         
          if(values.length!=this.showallHistoryHeaders.length-2)
          {
            let len = values.length;
            while(len<(this.showallHistoryHeaders.length-2))
            {
              values.push("-");
              cDate.push("-");
              len++;
            }
    
          }
          showHistorytbody.Value=values;
          showHistorytbody.CompletedDate = cDate;
    
          
    
          this.showallHistoryBody.push(showHistorytbody);
        
         
        
        }
    
        }, (error) => {
    
        }, () => {
        });
      }

      openGoalPopup:boolean = false;
      goalRangeDate:Date[];
      isSubmitted:boolean = false;
      currentValue:number=0;
      selectedServiceId:string;
      errorMsg: boolean = false;
      successMsg: boolean = false;
      @Input() admissionId:number;

      isNumeric(value: string): boolean {
        return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
      }

      setGoal(val){
        var activeServiceGoal = this.goalData?.filter(item => item.serviceId === val.serviceId);
        var isActive = activeServiceGoal?.some(item => item.targetActiveStatus == 'active');
        if(isActive){
          this.goalSetted = true;
          setTimeout(() => {
            this.goalSetted = false;
          }, 3000);
        }
        else{
          this.openGoalPopup = true;
          this.selectedServiceId = val?.serviceId;
          this.serviceGoalForm.controls['service'].setValue(val?.serviceName);
          this.currentValue = val?.latestValue;
        }
      }

      onDateChoose(controlName){
        const startDate = this.serviceGoalForm.controls['startDate'].value;
        const stopDate = this.serviceGoalForm.controls['stopDate'].value;
    
        if (controlName === 'startDate' && startDate && stopDate && startDate > stopDate) {
          this.serviceGoalForm.controls['stopDate'].setValue(null);
        } else if (controlName === 'stopDate' && startDate && stopDate && stopDate < startDate) {
          this.serviceGoalForm.controls['startDate'].setValue(null);
        }
      }

      startApiCall(val?){
        this.lastVisitId = val;
      }

      saveGoal(event){
        this.isSubmitted = true;
        var postData;
        if(this.serviceGoalForm.invalid){
          return;
        }
        event.target.disabled = true;
          postData = [{
            visitId: this.lastVisitId,
            regId: this.regId,
            ipId: this.patientIPOPStatus == 'IP' ? this.admissionId : null,
            serviceId: this.selectedServiceId,
            targetValue: Number(this.serviceGoalForm.controls['targetValue'].value),
            targetType: 'service',
            currentValue: this.currentValue ? Number(this.currentValue) : 0,
            targetName: this.serviceGoalForm.controls['service'].value,
            targetStartNotes:this.serviceGoalForm.controls['initialNotes'].value,
            targetProgressNotes: this.serviceGoalForm.controls['progressNotes'].value,
            targetStopNotes: this.serviceGoalForm.controls['stopNotes'].value,
            targetStartedDate: this.dateService.utcFromDate(this.serviceGoalForm.controls['startDate'].value),
            targetStopDate: this.dateService.utcToDate(this.serviceGoalForm.controls['stopDate'].value),
            targetActiveStatus: this.serviceGoalForm.controls['stopDate'].value > new Date() ? 'active' : 'closed',
            tenantId: this.tenandId,
            branchId: this.branchId,
            createdDate: new Date(),
            createdBy: parseInt(localStorage.getItem("userId")),
            createdIP: null,
            updatedDate: null,
            updatedBy: null,
            updatedIP: null
          }
        ];
        
        this.postAPI.searchList(`patientGoalSettingMst/savePatientGoalSetting`,postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data:any)=>{
         
        }, (error) => {
          this.isSubmitted = false;
          event.target.disabled = false;
          this.errorMsg = true;
          setTimeout(() => {
            this.errorMsg = false;
          }, 2000);
        }, () => {
          this.isSubmitted = false;
          this.openGoalPopup=false;
          this.serviceGoalForm.reset();
          event.target.disabled = false;
            this.successMsg = true;
            setTimeout(() => {
              this.successMsg = false;
            }, 2000);
            this.fetchAllData();
        });
      }

      fetchAllData(){
        this.labResultSrvc.targetList(`patientGoalSettingMst/getGoalSettingForVitals&Services`,this.regId,this.tenandId,this.branchId)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  
        this.goalData = data?.goalData;
  
       
      }, (error) => {
  
      }, () => {
      });
    }

      resetServiceGoal(){
        this.isSubmitted=false;
        this.serviceGoalForm.reset();
      }
}
